import React, { PropsWithChildren } from "react";
import "./styles/index.scss";
import CheckboxIcon from "../../icons/checkboxes/checkboxIcon";

type CheckBoxProps = PropsWithChildren<{
  className?: string;
  classLabel: string;
  disabled?: boolean;
  checked: boolean;
  indeterminate?: boolean;
  isNew: boolean;
  isDisabled?: boolean;
  onChange: (arg0: boolean) => void;
}>;

const CheckBox = ({
  onChange,
  checked,
  disabled = false,
  indeterminate,
  className,
  classLabel,
  isNew,
  isDisabled = false,
  children,
}: CheckBoxProps) => {
  const handleClick = () => {
    if (disabled) {
      return;
    }
    onChange(!checked);
  };

  let cls = className || "default-checkbox";
  if (checked) {
    cls += " checked";
  }

  return (
    <div className="checkbox-container" onClick={handleClick}>
      {(isNew && !disabled && (
        <CheckboxIcon
          isChecked={checked}
          isIndeterminate={indeterminate}
          isDisabled={isDisabled}
        />
      )) || <div className={cls} />}
      {!children ? null : (
        <div className={classLabel ? classLabel : "default-checkbox-label"}>
          {children}
        </div>
      )}
    </div>
  );
};

export default CheckBox;
